// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_cognito_identity_pool_id": "us-west-2:37cdd8ff-23e1-4ba5-a7b2-eecd2a954785",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_3KgfgWdCK",
    "aws_user_pools_web_client_id": "7lbhteeuvu47idlh71j31ur6ai",
    "aws_content_delivery_bucket": "progresstodojs-20190205222640-hostingbucket",
    "aws_content_delivery_bucket_region": "us-west-2",
    "aws_content_delivery_url": "https://d3j424ruozumrg.cloudfront.net",
    "aws_appsync_graphqlEndpoint": "https://ralm7ytw3jh2rf747amfvnpbgm.appsync-api.us-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS"
};


export default awsmobile;
